import React, { useState, createContext } from "react";


export const initState = { }

export const UserContext = createContext<UserState>(initState);
export const UserDispatchContext = createContext<Function>(() => null);

export default (props) => {
    const [filterState, setFilterState] = useState<UserState>(initState) 

    return (
        <UserContext.Provider value={filterState}>
             <UserDispatchContext.Provider value={setFilterState}>
                {props.children}
             </UserDispatchContext.Provider>
        </UserContext.Provider>
    );
  }

  interface UserState {
      name?: string,
      role?: string,
      apikey?: string
  }